import { render, staticRenderFns } from "./ProviderOrder.vue?vue&type=template&id=d980a1bc&"
import script from "./ProviderOrder.vue?vue&type=script&lang=js&"
export * from "./ProviderOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports